import { z } from "zod";
import { communityCoverImageSchema } from "./cover-image.js";
import { communityTestimonialSchema } from "./testimonial.js";

export const updateCommunityBrandingSchema = z
	.object({
		image: z.url().nullable().optional(),
		cover_images: z.array(communityCoverImageSchema).max(5).optional(),
		testimonials: z.array(communityTestimonialSchema).max(10).optional(),
	})
	.strict();

export type UpdateCommunityBrandingPayload = z.infer<typeof updateCommunityBrandingSchema>;
